export default {
  path: '/v5/upgrade',
  name: 'V5_upgrade',
  component: () => import('./UpgradePage.vue'),
};
